/* ============================================
   SOFLO SMOKE CLUB — MAIN JS
   ============================================ */

// === NAV SCROLL ===
const nav = document.querySelector('.nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 40);
  });
}

// === MOBILE NAV ===
const navToggle = document.querySelector('.nav-toggle');
const navMobile = document.querySelector('.nav-mobile');
if (navToggle && navMobile) {
  navToggle.addEventListener('click', () => {
    navMobile.classList.toggle('open');
    document.body.style.overflow = navMobile.classList.contains('open') ? 'hidden' : '';
  });
}

// === FAQ ACCORDION ===
document.querySelectorAll('.faq-question').forEach(q => {
  q.addEventListener('click', () => {
    const item = q.closest('.faq-item');
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });
});

// === TABS ===
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('[data-tabs]') || btn.parentElement.closest('.tabs-wrapper');
    const target = btn.dataset.tab;
    if (group) {
      group.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      group.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const panel = group.querySelector(`[data-panel="${target}"]`);
      if (panel) panel.classList.add('active');
    }
  });
});

// === CART COUNT ===
let cartCount = 0;
const cartCountEl = document.querySelector('.nav-cart-count');
function updateCart(n) {
  cartCount += n;
  if (cartCountEl) cartCountEl.textContent = cartCount;
}

// === ADD TO CART ===
document.querySelectorAll('.product-add').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const card = btn.closest('.product-card');
    const name = card?.querySelector('.product-name')?.textContent || 'Item';
    updateCart(1);
    showToast('✅', `${name}`, 'Added to cart');
    btn.textContent = '✓ Added';
    btn.style.background = 'rgba(0,255,136,0.15)';
    btn.style.borderColor = 'rgba(0,255,136,0.4)';
    btn.style.color = '#00ff88';
    setTimeout(() => {
      btn.textContent = 'Add to Cart';
      btn.style.background = '';
      btn.style.borderColor = '';
      btn.style.color = '';
    }, 1800);
  });
});

// === WISHLIST ===
document.querySelectorAll('.product-wishlist').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    btn.classList.toggle('active');
    btn.style.color = btn.classList.contains('active') ? '#ff2d78' : '';
    btn.style.borderColor = btn.classList.contains('active') ? '#ff2d78' : '';
    btn.innerHTML = btn.classList.contains('active') ? '♥' : '♡';
  });
});

// === TOAST ===
function showToast(icon, title, text) {
  const existing = document.querySelector('.toast');
  if (existing) existing.remove();
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `<span class="toast-icon">${icon}</span><div class="toast-text"><strong>${title}</strong>${text}</div>`;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 3500);
}

// === QTY CONTROLS ===
document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const isPlus = btn.dataset.action === 'plus';
    const display = btn.parentElement.querySelector('.qty-num');
    if (!display) return;
    let val = parseInt(display.textContent) || 1;
    if (isPlus) val++;
    else if (val > 1) val--;
    display.textContent = val;
  });
});

// === COUNTDOWN TIMERS ===
function startCountdown(el, endTime) {
  function tick() {
    const now = Date.now();
    const diff = Math.max(0, endTime - now);
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const hEl = el.querySelector('[data-timer-h]');
    const mEl = el.querySelector('[data-timer-m]');
    const sEl = el.querySelector('[data-timer-s]');
    if (hEl) hEl.textContent = String(h).padStart(2, '0');
    if (mEl) mEl.textContent = String(m).padStart(2, '0');
    if (sEl) sEl.textContent = String(s).padStart(2, '0');
    if (diff > 0) setTimeout(tick, 1000);
  }
  tick();
}
document.querySelectorAll('[data-countdown]').forEach(el => {
  const hours = parseInt(el.dataset.countdown) || 6;
  startCountdown(el, Date.now() + hours * 3600000);
});

// === POINTS BARS ===
document.querySelectorAll('.points-fill[data-fill]').forEach(el => {
  setTimeout(() => {
    el.style.width = el.dataset.fill + '%';
  }, 300);
});

// === SCROLL ANIMATIONS ===
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.animate-on-scroll').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(24px)';
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  observer.observe(el);
});

// === DELIVERY TOGGLE (CART) ===
const deliveryToggle = document.querySelector('[data-delivery-toggle]');
const deliverySection = document.querySelector('[data-delivery-section]');
if (deliveryToggle && deliverySection) {
  deliveryToggle.addEventListener('change', () => {
    deliverySection.style.display = deliveryToggle.checked ? 'block' : 'none';
  });
}

// === FILTER CHIPS ===
document.querySelectorAll('.filter-chip').forEach(chip => {
  chip.addEventListener('click', () => {
    const group = chip.closest('[data-filter-group]');
    if (group) {
      group.querySelectorAll('.filter-chip').forEach(c => c.classList.remove('active'));
    }
    chip.classList.toggle('active');
  });
});

// === SMOKE PASS TOGGLE (annual/monthly) ===
const passToggle = document.querySelector('[data-pass-toggle]');
if (passToggle) {
  passToggle.addEventListener('change', () => {
    const monthly = document.querySelectorAll('[data-price-monthly]');
    const annual = document.querySelectorAll('[data-price-annual]');
    if (passToggle.checked) {
      monthly.forEach(el => el.style.display = 'none');
      annual.forEach(el => el.style.display = 'block');
    } else {
      monthly.forEach(el => el.style.display = 'block');
      annual.forEach(el => el.style.display = 'none');
    }
  });
}

// === MOCK DELIVERY DRIVER ANIMATION ===
const driverDot = document.querySelector('.driver-dot');
if (driverDot) {
  // Already animated via CSS, just update ETA
  const etaEl = document.querySelector('.map-hud-eta');
  if (etaEl) {
    let eta = 14;
    setInterval(() => {
      if (eta > 1) { eta--; etaEl.textContent = eta + ' MIN'; }
    }, 8000);
  }
}

// === AGE GATE (simple session check) ===
(function() {
  // Storage access throws in Safari private mode / with cookies blocked. If it
  // does, fall back to an in-memory flag: show the gate, but never trap the user.
  let memoryVerified = false;
  function isVerified() {
    try { return !!sessionStorage.getItem('age_verified'); }
    catch (e) { return memoryVerified; }
  }
  function markVerified() {
    memoryVerified = true;
    try { sessionStorage.setItem('age_verified', '1'); } catch (e) {}
  }
  if (isVerified()) return;
  const ageGate = document.getElementById('age-gate');
  if (!ageGate) return;
  ageGate.style.display = 'flex';
  document.body.classList.add('age-gate-open');
  function dismiss() {
    ageGate.style.display = 'none';
    document.body.classList.remove('age-gate-open');
  }
  document.querySelector('#age-yes')?.addEventListener('click', () => {
    markVerified();
    dismiss();
  });
  document.querySelector('#age-no')?.addEventListener('click', () => {
    window.location.href = 'https://www.google.com';
  });
})();

// === CHECKOUT STEPS ===
const checkoutSteps = document.querySelectorAll('.checkout-step');
const checkoutPanels = document.querySelectorAll('.checkout-panel');
checkoutSteps.forEach((step, i) => {
  step.addEventListener('click', () => {
    checkoutSteps.forEach(s => s.classList.remove('active'));
    checkoutPanels.forEach(p => p.classList.remove('active'));
    step.classList.add('active');
    if (checkoutPanels[i]) checkoutPanels[i].classList.add('active');
  });
});

function ensureJoinBannerSection() {
  if (document.querySelector('#shopify-section-sf-join-club-banner')) return;

  const insertAfter = document.querySelector(
    '#shopify-section-sf-faq, #shopify-section-sf-faq-live, #sf-guides-inline-faq, #shopify-section-sf-guides-live, #shopify-section-sf-guides, #shopify-section-p-index-live'
  );
  if (!insertAfter || !window.fetch) return;

  const url = new URL(window.location.href);
  url.search = '';
  url.searchParams.set('sections', 'sf-join-club-banner');

  fetch(url.toString(), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const html = data && data['sf-join-club-banner'];
      if (!html || document.querySelector('#shopify-section-sf-join-club-banner')) return;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const section = wrapper.firstElementChild;
      if (section) insertAfter.insertAdjacentElement('afterend', section);
    })
    .catch(() => {});
}

// === INIT ===
document.addEventListener('DOMContentLoaded', () => {
  const staleInlineFaq = document.querySelector('#sf-guides-inline-faq');
  if (staleInlineFaq && document.querySelector('#shopify-section-sf-faq, #shopify-section-sf-faq-live')) {
    staleInlineFaq.setAttribute('aria-hidden', 'true');
    staleInlineFaq.style.display = 'none';
  }

  ensureJoinBannerSection();

  // Set first tab active if not set
  document.querySelectorAll('.tabs-wrapper').forEach(wrapper => {
    const firstBtn = wrapper.querySelector('.tab-btn');
    if (firstBtn && !wrapper.querySelector('.tab-btn.active')) {
      firstBtn.classList.add('active');
      const target = firstBtn.dataset.tab;
      const panel = wrapper.querySelector(`[data-panel="${target}"]`);
      if (panel) panel.classList.add('active');
    }
  });

});
